import React from 'react';
import { Button } from '../../../UIKit';
import { IImport } from '../../../Models/DTO/Import.model';
import { bindActionCreators } from 'redux';
import { requestSetCurrentImport } from '../../../store/imports';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PRIMARY_BLUE, WHITE } from '../../../Constants/Colors.constants';
import { useNavigation } from '../../../Hooks';
import { Route } from '~/Constants/Routes.constants';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(() => ({
  button: {
    margin: 'auto auto auto 0',
    height: '30px',
    backgroundColor: PRIMARY_BLUE,
    color: WHITE,
    fontSize: '14px',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: PRIMARY_BLUE,
    },
  },
}));

const useExpandedRow = () => {
  const { navigate } = useNavigation();
  const dispatch = useDispatch();
  const setCurrentImport = bindActionCreators(requestSetCurrentImport, dispatch);
  const { t } = useTranslation();

  const handleImportClick = (newImport: IImport) => {
    setCurrentImport(newImport);
    navigate(Route.IMPORT_REVIEW);
  };

  return {
    handleImportClick,
    t,
  };
};

export const ExpandedRow = ({ importRow }: { importRow: IImport }) => {
  const { t, handleImportClick } = useExpandedRow();
  const { classes } = useStyles();

  return (
    <Button type="button" onClick={() => handleImportClick(importRow)} className={classes.button}>
      {t('app.import.reviewAgain')}
    </Button>
  );
};
